export const formatPrice = (price) => {
  return `৳${Number(price).toLocaleString('en-BD')}`;
};

export const getEffectivePrice = (product) => {
  if (product.salePrice) return product.salePrice;
  if (product.discountedPrice) return product.discountedPrice;
  return product.price;
};

export const getDiscount = (product) => {
  const effective = getEffectivePrice(product);
  if (effective < product.price) {
    return Math.round(((product.price - effective) / product.price) * 100);
  }
  return 0;
};

export const statusColor = (status) => {
  const map = {
    processing: 'badge-blue',
    sent: 'badge-purple',
    delivered: 'badge-green',
    cancelled: 'badge-red',
    paid: 'badge-green',
    pending: 'badge-yellow',
    advance_paid: 'badge-blue',
  };
  return map[status] || 'badge-blue';
};

export const statusLabel = (status) => {
  const map = {
    processing: 'Processing',
    sent: 'Sent',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    paid: 'Paid',
    pending: 'Pending',
    advance_paid: 'Advance Paid',
  };
  return map[status] || status;
};

export const categoryIcons = {
  'T-Shirt': '👕',
  'Hoodie': '🧥',
  'Sweatshirt': '👔',
  'Bag': '👜',
  'Watch': '⌚',
  'Moneybag': '💰',
};
